import React, { Fragment } from "react";
import { CssData } from "./Data";
import { Card, CardBody, Col } from "reactstrap";
import HeaderCard from "../../Common/HeaderCard";
import { Highlight, themes } from "prism-react-renderer";

const CssMode = () => {
  return (
    <Fragment>
      <Col xl="6">
        <Card>
          <HeaderCard title={"CSS Mode"} />
          <CardBody>
            <Highlight theme={themes.vsDark} code={CssData} language="css">
              {({ style, tokens, getLineProps, getTokenProps }) => (
                <pre style={style}>
                  {tokens.map((line, i) => (
                    <div key={i} {...getLineProps({ line })}>
                      {line.map((token, key) => (
                        <span key={key} {...getTokenProps({ token })} />
                      ))}
                    </div>
                  ))}
                </pre>
              )}
            </Highlight>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default CssMode;
